import React from 'react';
import History from '../bharatBillpayImWallet/history';

function Index() {
    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>
                                    BBPS <span className='text-red'>Report</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className='card col-md-12'>
                            <div className='card-body'>
                                <History /> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;